import * as yup from 'yup';
import { cpf, cnpj } from 'cpf-cnpj-validator';

export const FornecedorDetalheSchema = yup.object().shape({
  Nome: yup
    .string()
    .required('Campo Obrigatório!')
    .min(3, 'O Campo deve ter no mínimo 3 caracteres'),
  CpfCnpj: yup.string()
    .required('Campo Obrigatório!')
    .matches(/^[0-9.,-/]*$/, 'Apenas caracteres numéricos são permitidos')
    .transform((value) => value.replace(/[^\d]/g, ''))
    .test('len', 'Deve ter 11 ou 14 dígitos', (val) => {
      return val ? val.length === 11 || val.length === 14 : false;
    })
    .test('cpf-cnpj-valido', 'CPF/CNPJ inválido', (val) => {
      if (!val) return true;
      if (val.length === 11) return cpf.isValid(val);
      if (val.length === 14) return cnpj.isValid(val);
      return true;
    }),
  Cep: yup.string(),
  Endereco: yup
    .string()
    .min(10, 'O Campo deve ter no mínimo 10 caracteres')
    .required(), //.required("Campo Obrigatório!").min(3, "O Campo deve ter no mínimo 3 caracteres"),
  Numero: yup.number().typeError('Por favor, insira um número válido'), //.required("Campo Obrigatório!"),
  Bairro: yup.string().required('Campo obrigatório'),
  Cidade: yup.string().required('Campo obrigatório'),
  Estado: yup.string().required('Campo obrigatório'),
  Email: yup.string().required('Campo obrigatório'),
});
